import LandingPage from './landing_page/landing_page.svelte';
import AboutUs from './about_us/about_us.svelte';
import applyProgram from './apply_to_drapper/applyProgram.svelte';
import ContactUs from './contact_us/contact_us.svelte';
import Pledge from './pledge/pledge.svelte';
import HeroPage from './programs/hero_training_page.svelte';
import FundamentalPage from './programs/fundamental_program_page.svelte';
import CorporativePage from './programs/corporative_page.svelte';
import CoporativeAcceleratorPage from './programs/corporate_accelerator_page.svelte';
import InvestPage from './programs/invest_page.svelte';
import VcxPage from './programs/vcx_program_page.svelte';
import BlockchainPage from './programs/blockchain_accelerator.svelte';
import GlobalPage from './programs/global_govt_page.svelte';
import PrivacyPolicy from './privacy_policy/privacy_policy.svelte';
import MediaCenter from './media_center.svelte';
import Payment from './apply_to_drapper/payment_page.svelte';
import Applyhero from './apply_to_drapper/apply_to_hero.svelte';
import Applyfundamental from './apply_to_drapper/apply_to_fundamental.svelte';
import Formfee from './apply_to_drapper/form_fee.svelte';
import alumni from './programs/alumni.svelte';
import houseCeek from './programs/houseOfCeek.svelte';
import KanooPage from './programs/kanooPage.svelte';
import Apply from './apply_to_drapper/apply.svelte';
import ApplyCeek from './apply_to_drapper/forth_form_houseofCeek.svelte';

const pages = {
    '/': LandingPage,
    '/about_us': AboutUs,
    '/applyProgram': applyProgram,
    '/contact_us': ContactUs,
    '/pledge': Pledge,
    '/program_hero': HeroPage,
    '/program_fundamental': FundamentalPage,
    '/program_coporative': CorporativePage,
    '/program_coporative_accelerator': CoporativeAcceleratorPage,
    '/program_invest': InvestPage,
    '/program_vcx': VcxPage,
    '/program_blockchain': BlockchainPage,
    '/program_global': GlobalPage,
    '/privacy_policy': PrivacyPolicy,
    '/media_center': MediaCenter,
    '/payment': Payment,
    '/alumni': alumni,
    '/applyhero': Applyhero,
    '/applyfundamental': Applyfundamental,
    '/Formfee': Formfee,
    '/houseCeek': houseCeek,
    '/kanoopage': KanooPage,
    '/apply': Apply,
    '/applyceek': ApplyCeek,
};

export default pages;
